import React from 'react';
import { Box, useBreakpointValue } from '@stockx/ui';
import { EXPERIMENTS } from '@app/config';
import { useExperiment } from '@app/experiments';
import useContentVariant from '../Content/hooks/useContentVariant';
import MainNavigation from './components/MainNavigation';

const Navigation = () => {
  const variant = useContentVariant();

  const { isMobile } = useBreakpointValue();
  const isWomensNavVariant =
    useExperiment(EXPERIMENTS.ab_home_add_womens_navigation_web) === 'variant';

  if (!isWomensNavVariant || variant !== 'human' || isMobile) {
    return null;
  }

  return (
    <Box
      width="100%"
      backgroundColor="neutral.white"
      data-testid="Navigation"
      zIndex="4"
    >
      <MainNavigation />
    </Box>
  );
};

export default Navigation;
